import { useEffect, useState } from 'react';
import { Box, LinearProgress, Stack, Typography } from '@mui/material';

/**
 * Time to the next Live Screening refresh - same idea as ITrade4You.Partner.UI's Live Prediction
 * RefreshCountdown: driven by the session's own scanInterval and the last reading's time.
 */
export default function RefreshCountdown({ lastUpdated, intervalMs }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const since = Math.max(0, now - new Date(lastUpdated).getTime());
  const remaining = Math.max(0, intervalMs - since);
  const due = remaining === 0;

  return (
    <Box sx={{ minWidth: { xs: '100%', sm: 220 } }}>
      <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
          {due ? 'Refreshing…' : 'Next refresh'}
        </Typography>
        {!due && (
          <Typography variant="caption" sx={{ fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}>
            {Math.ceil(remaining / 1000)}s
          </Typography>
        )}
      </Stack>
      <LinearProgress
        variant={due ? 'indeterminate' : 'determinate'}
        value={Math.min(100, (since / intervalMs) * 100)}
        color="secondary"
        sx={{ height: 6, borderRadius: 3, '& .MuiLinearProgress-bar': { borderRadius: 3, transition: 'transform 1s linear' } }}
      />
    </Box>
  );
}
